import { type YDatabase } from '@databases/collab/y-database';
import { type MetaSdkContract } from '@databases/sdk-types';
import { type Result } from 'neverthrow';

import { setLockedSchema, type SetLockedInput } from '../domain/meta/schemas/locked.ts';
import { type DatabaseMetaSnapshot } from '../domain/meta/types.ts';
import { parse, tryMutate } from '../domain/result.ts';
import { toggleLockStructure } from '../handlers/db/toggle-lock-structure.ts';
import { type SdkError } from '../types.ts';

export type { SetLockedInput } from '../domain/meta/schemas/locked.ts';

/**
 * Manages database-level metadata (structure lock, default view).
 */
export class MetaSdk implements MetaSdkContract {
  constructor(private readonly ydb: YDatabase) {}

  get(): DatabaseMetaSnapshot {
    return {
      isLocked: this.ydb.isLocked ?? false,
      defaultViewId: this.ydb.defaultViewId
    };
  }

  setLocked(input: SetLockedInput): Result<void, SdkError> {
    return parse(setLockedSchema, input).andThen(({ isLocked }) =>
      tryMutate(() => toggleLockStructure(this.ydb, isLocked))
    );
  }
}
